<a class="nav-link nav-hover" matRipple>
    <mat-icon class="nav-link-icon" *ngIf="item.icon">{{item.icon}}</mat-icon>
    <span class="nav-link-title">{{item.title}}</span>
    <mat-icon class="collapse-arrow">chevron_right</mat-icon>
</a>

<div class="children" [ngClass]="{'open': isOpen}">

    <div class="nav navbar-light">

        <ng-container *ngFor="let item of item.children">
            <wtf-nav-horizontal-item *ngIf="item.type=='item'" [item]="item"></wtf-nav-horizontal-item>
            <wtf-nav-horizontal-collapse *ngIf="item.type=='collapse'" [item]="item"></wtf-nav-horizontal-collapse>
            <wtf-nav-horizontal-collapse *ngIf="item.type=='group'" [item]="item"></wtf-nav-horizontal-collapse>
        </ng-container>

    </div>

</div>
